import { useField } from "formik"
import { Dropdown } from "primereact/dropdown"

const FormikDropdown = ({
  id,
  placeholder,
  options,
  showOnFocus,
  onChange,
  filter = false,
  emptyMessage = "Sin resultados",
  showClear = false,
  className,
  disabled = false,
  name,
  errors = true,
  value,
  editable = false,
  ...props
}: $TSMigrationFixMe) => {
  const [field, meta] = useField(name)

  const errorMsg = meta?.error && meta?.touched ? meta.error : ""

  return (
    <>
      <Dropdown
        id={id}
        showOnFocus={showOnFocus}
        placeholder={placeholder}
        options={options || []}
        filter={filter}
        className={`${className} ${errorMsg ? "p-invalid" : ""}`}
        emptyMessage={emptyMessage}
        disabled={disabled}
        {...field}
        showClear={showClear}
        onChange={onChange || field.onChange}
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        onBlur={(e) => field.onBlur(e, id)}
        value={value}
        editable={editable}
        {...props}
      />
      {errorMsg && errors && (
        <small className='p-error p-d-block'>{errorMsg}</small>
      )}
    </>
  )
}

export default FormikDropdown
